import { getCurrentSpace, useCurrentSpace } from 'src/hooks/space';
import { SpacePlanType } from 'src/redux/types';
import { getSpaceBySpaceId } from './get-space';
import { useSpace } from './use-current-space';

export const PRO_SPACE_PLAN: string[] = [
  SpacePlanType.team,
  SpacePlanType.pro,
  SpacePlanType.smallTeam,
  SpacePlanType.appsumoTier1,
];

export const TEAM_SPACE_PLAN: string[] = [
  // SpacePlanType.freeTeam,
  SpacePlanType.team,
  SpacePlanType.smallTeam,
  SpacePlanType.appsumoTier2,
  SpacePlanType.appsumoTier3,
  SpacePlanType.appsumoTier4,
];

// personal
export const PERSONAL_SPACE_PLAN: string[] = [
  SpacePlanType.freePersonal,
  SpacePlanType.pro,
  SpacePlanType.appsumoTier1,
];

export const isTeamProSpace = (planType?: string) =>
  Boolean(planType && TEAM_SPACE_PLAN.includes(planType));

export const isPersonalSpace = (planType?: string) =>
  Boolean(planType && PERSONAL_SPACE_PLAN.includes(planType));

/** 如果是在分享页调用，需要传具体的spaceId，未登录用户的useCurrentSpace是不对的 */
export const useIsProSpace = (spaceId?: string) => {
  const currentSpace = useCurrentSpace();
  const space = useSpace(spaceId ?? currentSpace.uuid);

  const isProSpace =
    space.planType === SpacePlanType.appsumoTier1 ||
    space.planType === SpacePlanType.appsumoTier2 ||
    space.planType === SpacePlanType.appsumoTier3 ||
    space.planType === SpacePlanType.appsumoTier4 ||
    space.planType === SpacePlanType.team ||
    space.planType === SpacePlanType.pro ||
    space.planType === SpacePlanType.smallTeam;

  return isProSpace;
};

/** 付费团队空间 */
export const useIsTeamProSpace = (spaceId?: string, onlyTeam?: boolean) => {
  const currentSpace = useCurrentSpace();
  const isPro = useIsProSpace(spaceId);
  const space = useSpace(spaceId || currentSpace.uuid);
  if (!space.planType) return false;
  if (onlyTeam) {
    return [
      SpacePlanType.team,
      SpacePlanType.appsumoTier2,
      SpacePlanType.appsumoTier3,
      SpacePlanType.appsumoTier4,
    ].includes(space.planType as SpacePlanType);
  }
  return isPro;
};

export const getIsProSpace = (spaceId?: string) => {
  const currentSpace = spaceId ? getSpaceBySpaceId(spaceId) : getCurrentSpace();
  if (currentSpace === undefined) return false;

  const isProSpace =
    currentSpace.planType === SpacePlanType.team ||
    currentSpace.planType === SpacePlanType.pro ||
    currentSpace.planType === SpacePlanType.smallTeam;
  currentSpace.planType === SpacePlanType.appsumoTier1;
  currentSpace.planType === SpacePlanType.appsumoTier2;
  currentSpace.planType === SpacePlanType.appsumoTier3;
  currentSpace.planType === SpacePlanType.appsumoTier4;

  return isProSpace;
};

export const getIsFreeSpaceLimit = (spaceId?: string) => {
  const currentSpace = spaceId ? getSpaceBySpaceId(spaceId) : getCurrentSpace();
  return currentSpace.planType === SpacePlanType.freePersonal;
};

/** 空间版本是否受到限制 */
export const useIsFreeSpaceLimit = (spaceId?: string) => {
  const currentSpace = useCurrentSpace();
  const space = useSpace(spaceId ?? currentSpace.uuid);
  return space.planType === SpacePlanType.freePersonal || space.planType === SpacePlanType.freeTeam;
};

export const useIsShowAd = (spaceId?: string) => {
  const currentSpace = useCurrentSpace();
  spaceId = spaceId ?? currentSpace.uuid;
  const isFreeSpaceLimit = useIsFreeSpaceLimit(spaceId);
  const space = useSpace(spaceId);
  const { isShowAd = true } = space;

  if (__PRIVATE__) return false;
  if (isFreeSpaceLimit) {
    return true;
  }

  return isShowAd;
};
